import objectToParams from './objectToParams'

function callAPI(request, requiredHeaders) {
  const query = request.params ? '?' + objectToParams(request.params) : ''
  const headers = new Headers()
  if (request.payload) {
    headers.append('Content-Type', 'application/json')
    request.payload = JSON.stringify(request.payload)
  }

  if (requiredHeaders) {
    Object.keys(requiredHeaders).forEach(x => {
      headers.append(x, requiredHeaders[x])
    })
  }
  const options = {
    method: request.method || 'GET',
    headers: headers,
    credentials: 'same-origin',
    mode: 'cors',
    body: request.payload,
  }
  return fetch(`${request.url}${query}`, options).then(response =>
    response.status === 204 ? response.status : response.json()
  )
}

export default callAPI
